import cacheService from '../../../services/cacheService';
import submitCommand from '../../../services/submitCommand';

type Step = {
  id: string;
  taskListId: { id: string };
  _type: string;
};

type Entity = {
  step: Step;
  previous: string;
  next: string;
};

export const addEntityToPathway = (pathwayId: string, entity: Entity, initiatingUserId?: string) => {
  cacheService.remove(`/v1/workflows/${pathwayId}`);
  return submitCommand(
    pathwayId,
    { ...entity, id: pathwayId, initiatingUserId },
    'InsertStepToWorkflow',
    'StepIsInsertedToWorkflow',
    'WorkflowError'
  );
};
